import { FaSyncAlt, FaPlus, FaTrash, FaCopy, FaFileExport, FaEdit } from 'react-icons/fa';
import './Toolbar.css';
import React from 'react';

{/* <button className="action-button" onClick={openSourceModal}>Add Source</button>
<button className="action-button" onClick={handleGenerateBlog}>Generate Blog from Selected</button> */}

function Toolbar({ handleRefresh, handleAdd, handleDelete, handleGenerateConsolidatePrompt, handlePasteQAPairs, handleCopy, handleBulkConsolidate, handleExportCSV, selectedStatus, handleSetStatus, handleTagSelected }) {
    return (
      <div className="toolbar-container">
        <div className="kga-actions">
          <div className="action-button" onClick={handleRefresh}>
            <FaSyncAlt />
            <span className="tooltip">Refresh the table.</span>
          </div>

          <div className="action-button" onClick={handleAdd}>
            <FaPlus />
            <span className="tooltip">Add a new KGA.</span>
            Add
          </div>

          <div className="action-button" onClick={handleDelete}>
            <FaTrash />
            <span className="tooltip">Delete selected KGA's.</span>
            Delete
          </div>

          {/* <div className="action-button" onClick={handleGenerateConsolidatePrompt}>
            <FaEdit />
            <span className="tooltip">Generate a prompt for consolidation. Paste this prompt into ChatGPT!</span>
            Generate Prompt
          </div> */}

          <div className="action-button" onClick={handleCopy}>
            <FaCopy />
            <span className="tooltip">Copy selected KGA's to clipboard.</span>
            Copy Selected (JSON)
          </div>

          <div className="action-button" onClick={handlePasteQAPairs}>
            <FaEdit />
            <span className="tooltip">Reads from your clipboard and adds QA pairs to the database.</span>
            Paste (JSON)
          </div>

          <div className="action-button" onClick={handleExportCSV}>
            <FaFileExport />
            <span className="tooltip">Export selected rows as CSV.</span>
            Export Selected (CSV)
          </div>

          <div className="action-button" onClick={handleBulkConsolidate}>
            <FaFileExport />
            <span className="tooltip">Consolidate selected KGA's. New KGA's will be generated and their status as "New".</span>
            Consolidate Selected
          </div>

          <div className="action-button select-container">
            <select className="toolbar-select" value={selectedStatus} onChange={handleSetStatus}>
              <option value="">Update Status for Selected</option>
              <option value="Approved">Approved</option>
              <option value="Pending">Pending</option>
              <option value="Expired">Expired</option>
              <option value="Invalid">Invalid</option>
              <option value="other">Other</option>
            </select>
            <span className="tooltip">Update status of selected KGA's.</span>
          </div>
          <div className="action-button" onClick={handleTagSelected}>
            <FaEdit />
            <span className="tooltip">Add a tag for selected rows</span>
            Tag Selected
          </div>
        </div>
      </div>
    );
}

export default Toolbar;
